/**
 * 全 BOM 位置名稱重複檢查（對齊 v1 BomContext.checkPositionDuplicate）。
 */

function normalizePositionName(name) {
  return (name ?? '').trim().toUpperCase();
}

export function buildBomPositionNameIndex(groups = []) {
  const index = new Map();

  (groups ?? []).forEach((group, groupIndex) => {
    (group?.materials ?? []).forEach((material, materialIndex) => {
      (material?.positions ?? []).forEach((position, positionIndex) => {
        const trimmed = (position?.name ?? '').trim();
        if (!trimmed) {
          return;
        }

        const key = normalizePositionName(trimmed);
        if (!index.has(key)) {
          index.set(key, []);
        }

        index.get(key).push({
          groupIndex,
          groupName: group?.name ?? '',
          materialIndex,
          mtrNo: material?.mtrNo ?? '',
          mtrName: material?.mtrName ?? '',
          positionIndex,
          positionName: trimmed,
        });
      });
    });
  });

  return index;
}

/**
 * @param {object} options
 * @param {Array} options.groups
 * @param {string} options.positionName
 * @param {{ groupIndex: number, materialIndex: number, positionIndex: number }|null} [options.exclude]
 */
export function checkBomPositionDuplicate({ groups, positionName, exclude = null }) {
  const normalized = normalizePositionName(positionName);
  if (!normalized) {
    return { isDuplicate: false, duplicateLocations: [] };
  }

  const index = buildBomPositionNameIndex(groups);
  const locations = (index.get(normalized) ?? []).filter((location) => {
    if (!exclude) {
      return true;
    }
    return !(
      location.groupIndex === exclude.groupIndex
      && location.materialIndex === exclude.materialIndex
      && location.positionIndex === exclude.positionIndex
    );
  });

  return {
    isDuplicate: locations.length > 0,
    duplicateLocations: locations,
  };
}

/** 供 submit 阻擋：回傳所有跨物料重複的位置名稱。 */
export function collectBomPositionDuplicates(groups = []) {
  const index = buildBomPositionNameIndex(groups);
  const duplicates = [];

  index.forEach((locations) => {
    if (locations.length > 1) {
      duplicates.push({
        positionName: locations[0].positionName,
        locations,
      });
    }
  });

  return duplicates;
}
